import React, { FC } from "react";
import { ADMIN_TALENT_UNLOCK_REVENUE } from "../graphql";
import { RevenueDetailPage } from "./RevenueDetailPage";

export const TalentUnlockRevenuePage: FC = () => {
  return (
    <RevenueDetailPage
      title="Talent unlock revenue"
      description="Revenue from businesses unlocking applicant details."
      query={ADMIN_TALENT_UNLOCK_REVENUE}
      queryRootField="adminTalentUnlockRevenue"
    />
  );
};
